import React from "react";
import { Grid } from "grommet";
import { useSelector } from "react-redux";
import { CustomCard } from "./CustomCard";

export const CompetetiveProductsGrid = ({ productsList, competitorId, history, size, ...rest }) => {
    const products = useSelector(() => {
        productsList.sort((a, b) => (a.order > b.order) ? 1 : -1);
        return productsList.map((group, index) => {
            const productsDet = {
                id: group.id,
                name: group.competitor_product_name,
                description: group.product_type,
                page_link: `/competitor/${competitorId}/${group.id}/resource-center/1`,
            };
            return (
                <CustomCard
                    key={productsDet.id}
                    title={productsDet.name}
                    description={productsDet.description}
                    onClickHandler={() => {
                        history.push(productsDet.page_link);
                    }}
                />
            );
        });
    });

    return (
        <Grid
            columns={"20%"} gap={"medium"}
            rows={[["auto", "full"]]}
            {...rest}
            pad='medium'
            fill
        >
            {products}
        </Grid>
    );
};